import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducerProvider, reducerToken } from './reducers';
import { SNACKBAR_FEATURE } from './snackbar-state';

@NgModule({
  imports: [StoreModule.forFeature(SNACKBAR_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class SnackbarStoreModule {}
